import { Button } from "@component/button";
import AuthLayout from "@container/layout/auth";
import { WorkspaceCompanyTable } from "@container/workspace-company-table";
import { PlusIcon } from "lucide-react";
import { Link } from "react-router-dom";

export default function WorkspaceListPage() {
    return (
        <AuthLayout withoutHeader>
            <div className="space-y-6">
                {/* Title and CTA */}
                <div className="flex items-center justify-between">
                    <Link to="/workspaces/create">
                        <Button className="bg-blue-600 hover:bg-blue-700 text-white">
                            <PlusIcon className="h-4 w-4" />
                            Create Company Workspace
                        </Button>
                    </Link>
                </div>

                <WorkspaceCompanyTable />
            </div>
        </AuthLayout>
    );
}